import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function AnalyticsTracker() {
  const location = useLocation()
  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return
    const timer = window.setTimeout(() => {
      void import('./analytics-service').then(({ trackEvent }) => trackEvent('page_view'))
    }, 1000)
    return () => window.clearTimeout(timer)
  }, [location.pathname, location.search])
  return null
}
